"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const NegativeMonthsError_1 = __importDefault(require("@react/web/Common/NumberFormatter/error/NegativeMonthsError"));
function roundedNumberFormat(numberToFormat) {
    const roundedNumber = Math.round(numberToFormat);
    return roundedNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}
class NumberFormatter {
    static formatPrice(price) {
        const formattedPrice = roundedNumberFormat(price);
        return `${formattedPrice} Kč`;
    }
    static formatMileage(mileage) {
        const formattedMileage = roundedNumberFormat(mileage);
        return `${formattedMileage} km`;
    }
    static getMonthsLabel(months) {
        if (months < 0) {
            throw new NegativeMonthsError_1.default(months);
        }
        let monthsSuffix = 'měsíců';
        if (months === 1) {
            monthsSuffix = 'měsíc';
        }
        if (months > 1 && months <= 4) {
            monthsSuffix = 'měsíce';
        }
        return `${monthsSuffix}`;
    }
    static formatMonths(months) {
        const formattedMonths = roundedNumberFormat(months);
        return `${formattedMonths} ${this.getMonthsLabel(months)}`;
    }
}
exports.default = NumberFormatter;
